import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "team",
  class: "team-wrap pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "team-card style1" }
const _hoisted_7 = { class: "team-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "team-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-4 col-md-6",
            key: team.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": team.datadelay
          }, [
            _createElementVNode("a", {
              href: team.url
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: team.image,
                    alt: "Image"
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", null, _toDisplayString(team.name), 1),
                  _createElementVNode("span", null, _toDisplayString(team.designation), 1)
                ])
              ])
            ], 8, _hoisted_5)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}